import { MIME_TYPES } from '@inno-sdks/mime-types'

export const mimeTypes = {
  document: {
    doc: MIME_TYPES.doc,
    docm: MIME_TYPES.docm,
    docx: MIME_TYPES.docx,
    dot: MIME_TYPES.dot,
    dotm: MIME_TYPES.dotm,
    dotx: MIME_TYPES.dotx,
    epub: MIME_TYPES.epub,
    fb2: MIME_TYPES.fb2,
    fodt: MIME_TYPES.fodt,
    hwp: MIME_TYPES.hwp,
    hwpx: MIME_TYPES.hwpx,
    md: MIME_TYPES.md,
    mht: MIME_TYPES.mht,
    mhtml: MIME_TYPES.mhtml,
    odt: MIME_TYPES.odt,
    ott: MIME_TYPES.ott,
    pages: MIME_TYPES.pages,
    rtf: MIME_TYPES.rtf,
    stw: MIME_TYPES.stw,
    sxw: MIME_TYPES.sxw,
    txt: MIME_TYPES.txt,
    wps: MIME_TYPES.wps,
    wpt: MIME_TYPES.wpt
  },
  plainDocument: {
    txt: MIME_TYPES.txt,
    vtt: MIME_TYPES.vtt,
    xml: MIME_TYPES.xml,
    html: MIME_TYPES.html,
    htm: MIME_TYPES.htm
  },
  spreadsheet: {
    csv: MIME_TYPES.csv,
    et: MIME_TYPES.et,
    ett: MIME_TYPES.ett,
    fods: MIME_TYPES.fods,
    numbers: MIME_TYPES.numbers,
    ods: MIME_TYPES.ods,
    ots: MIME_TYPES.ots,
    sxc: MIME_TYPES.sxc,
    xls: MIME_TYPES.xls,
    xlsb: MIME_TYPES.xlsb,
    xlsm: MIME_TYPES.xlsm,
    xlsx: MIME_TYPES.xlsx,
    xlt: MIME_TYPES.xlt,
    xltm: MIME_TYPES.xltm,
    xltx: MIME_TYPES.xltx,
    xml: MIME_TYPES.xml
  },
  presentation: {
    dps: MIME_TYPES.dps,
    dpt: MIME_TYPES.dpt,
    fodp: MIME_TYPES.fodp,
    key: MIME_TYPES.key,
    odg: MIME_TYPES.odg,
    odp: MIME_TYPES.odp,
    otp: MIME_TYPES.otp,
    pot: MIME_TYPES.pot,
    potm: MIME_TYPES.potm,
    potx: MIME_TYPES.potx,
    pps: MIME_TYPES.pps,
    ppsm: MIME_TYPES.ppsm,
    ppsx: MIME_TYPES.ppsx,
    ppt: MIME_TYPES.ppt,
    pptm: MIME_TYPES.pptm,
    pptx: MIME_TYPES.pptx,
    sxi: MIME_TYPES.sxi
  },
  pdf: {
    djvu: MIME_TYPES.djvu,
    oxps: MIME_TYPES.oxps,
    pdf: MIME_TYPES.pdf,
    xps: MIME_TYPES.xps
  },
  diagram: {
    vsdm: MIME_TYPES.vsdm,
    vsdx: MIME_TYPES.vsdx,
    vssm: MIME_TYPES.vssm,
    vssx: MIME_TYPES.vssx,
    vstm: MIME_TYPES.vstm,
    vstx: MIME_TYPES.vstx
  },
  drawing: {
    excalidraw: MIME_TYPES.excalidraw
  },
  image: {
    png: MIME_TYPES.png,
    bmp: MIME_TYPES.bmp,
    gif: MIME_TYPES.gif,
    jpg: MIME_TYPES.jpg,
    jpeg: MIME_TYPES.jpeg,
    tiff: MIME_TYPES.tiff,
    tif: MIME_TYPES.tif,
    svg: MIME_TYPES.svg,
    pjpeg: MIME_TYPES.pjpeg,
    webp: MIME_TYPES.webp,
    wbmp: MIME_TYPES.wbmp,
    ico: MIME_TYPES.ico,
    cur: MIME_TYPES.cur,
    heif: MIME_TYPES.heif,
    heic: MIME_TYPES.heic,
    pbm: MIME_TYPES.pbm,
    pgm: MIME_TYPES.pgm,
    ppm: MIME_TYPES.ppm,
    xpm: MIME_TYPES.xpm,
    avif: MIME_TYPES.avif
  },
  audio: {
    mp3: MIME_TYPES.mp3,
    wav: MIME_TYPES.wav,
    aac: MIME_TYPES.aac,
    flac: MIME_TYPES.flac,
    m4a: MIME_TYPES.m4a,
    wma: MIME_TYPES.wma,
    aiff: MIME_TYPES.aiff,
    aif: MIME_TYPES.aif,
    au: MIME_TYPES.au,
    ogg: MIME_TYPES.ogg,
    weba: MIME_TYPES.weba,
    midi: MIME_TYPES.midi,
    amr: MIME_TYPES.amr
  },
  video: {
    mp4: MIME_TYPES.mp4,
    mpeg: MIME_TYPES.mpeg,
    avi: MIME_TYPES.avi,
    webm: MIME_TYPES.webm,
    mov: MIME_TYPES.mov,
    '3gp': MIME_TYPES['3gp'],
    '3g2': MIME_TYPES['3g2'],
    ogv: MIME_TYPES.ogv,
    wmv: MIME_TYPES.wmv,
    flv: MIME_TYPES.flv,
    asf: MIME_TYPES.asf,
    wmx: MIME_TYPES.wmx,
    wvx: MIME_TYPES.wvx,
    mkv: MIME_TYPES.mkv,
    m4v: MIME_TYPES.m4v,
    m3u8: MIME_TYPES.m3u8,
    ts: MIME_TYPES.ts
  },
  archive: {
    zip: MIME_TYPES.zip,
    tar: MIME_TYPES.tar,
    rar: MIME_TYPES.rar,
    '7z': MIME_TYPES['7z'],
    gz: MIME_TYPES.gz,
    gzip: MIME_TYPES.gzip,
    bz2: MIME_TYPES.bz2,
    xz: MIME_TYPES.xz,
    lzma: MIME_TYPES.lzma,
    lzip: MIME_TYPES.lzip,
    lzop: MIME_TYPES.lzop,
    zst: MIME_TYPES.zst,
    cpio: MIME_TYPES.cpio,
    iso: MIME_TYPES.iso,
    z: MIME_TYPES.z,
    zlib: MIME_TYPES.zlib
  },
  other: {
    eps: MIME_TYPES.eps,
    psw: MIME_TYPES.psw,
    cda: MIME_TYPES.cda,
    dbf: MIME_TYPES.dbf,
    odc: MIME_TYPES.odc,
    swf: MIME_TYPES.swf,
    pub: MIME_TYPES.pub,
    woff: MIME_TYPES.woff,
    sit: MIME_TYPES.sit,
    wmf: MIME_TYPES.wmf,
    pntg: MIME_TYPES.pntg,
    psd: MIME_TYPES.psd
  }
} as const
